<template>
	<div class="download-page" >
		<div class="page-header" @click="downloadApp()">
			<img class="logo-img" src="./../assets/logo.png" alt="" />
			<div class="page-header-content">
				<div class="title-1">{{appName}}</div>
				<div class="right-bottom">
					<div class="download-btn">Install</div>
				</div>
			</div>
		</div>
		<div class="scores-box">
			<div class="scores-card">
				<div class="scores-card-top">19k Scores</div>
				<div class="scores-card-center">4.9</div>
				<div class="scores-card-bottom">★★★★★</div>
			</div>
			<div class="scores-card">
				<div class="scores-card-top">Age</div>
				<div class="scores-card-center">18+</div>
				<div class="scores-card-bottom">years old</div>
			</div>
			<div class="scores-card">
				<div class="scores-card-top">Language</div>
				<div class="scores-card-center">EN</div>
				<div class="scores-card-bottom">english</div>
			</div>
			
		</div>
		<div class="banner-imgs-box">
			<div class="imgs-list">
				<img class="app-banner-img" src="./../assets/download_11.png" alt="" />
				<img class="app-banner-img" src="./../assets/download_12.png"  alt="" />
				<img class="app-banner-img" src="./../assets/download_13.png"  alt="" />
			</div>
		</div>
		<div class="introduce-box">
			<div class="introduce-title"> About this app </div>
			<div class="introduce-content">
				<p>About this application {{appName}}, its mobile application provides investors with high-quality stock trading advice, and new users can experience the 30-day membership service for free for the first time.</p>
				<br />
				<p>Member advantages:</p>
				<br />
				<p>Multiple securities trading team analysts provide stock trading advice with an accuracy of 90% after extensive calculations.</p>
			</div>
		</div>
		<div class="update-box">
			<div class="title"> Updated on </div>
			<div class="content"> Mar 22, 2024 </div>
		</div>
		<div class="comments-box">
			<div class="comments-box-title">
				Scoring and comments
			</div>
			<div class="comments-box-content">
				<div class="left">
					<div class="num">4.9</div>
					<div class="tips">Full mark 5 points</div>
				</div>
				<div class="right">
					<div class="star_row">
						<div class="linebox">
							<div class="v1"></div>
						</div>
					</div>
					<div class="star_row">
						<div class="linebox">
							<div class="v2"></div>
						</div>
					</div>
					<div class="star_row">
						<div class="linebox">
							<div class="v3"></div>
						</div>
					</div>
					<div class="star_row">
						<div class="linebox">
							<div class="v4"></div>
						</div>
					</div>
					<div class="star_row">
						<div class="linebox">
							<div class="v5"></div>
						</div>
					</div>
					<div class="tips">19k Scores</div>
				</div>
			</div>
		</div>
		
		<div class="info-box">
			<div class="title">information</div>
			<div class="info-box-cell">
				<div class="left">size</div>
				<div class="right">8.1 MB</div>
			</div>
			<div class="info-box-cell">
				<div class="left">compatibility</div>
				<div class="right" v-if="system == 'ios'">IOS 15.7 or later is required. Compatible with iPhone, iPad and iPod touch.</div>
				<div class="right" v-else>Android 15.7 or later is required.</div>
			</div>
			<div class="info-box-cell">
				<div class="left">language</div>
				<div class="right">English</div>
			</div>
			<div class="info-box-cell">
				<div class="left">Age classification</div>
				<div class="right">Limited to 18 years old and above</div>
			</div>
			<div class="info-box-cell">
				<div class="left">Copyright</div>
				<div class="right">@2018-2024 App Developer Inc</div>
			</div>
			<div class="info-box-cell">
				<div class="left">Price</div>
				<div class="right">free</div>
			</div>
			<div class="info-box-cell">
				<div class="left">Privacy policy</div>
				<div class="right">✋</div>
			</div>
		</div>
		<div class="disclaimer">
			<div>Disclaimer：</div>
			<div class="content">This website only provides app download, installation and hosting for developers. The content and operation related matters in the app are the responsibility of app developers, which has nothing to do with this website</div>
		</div>
		<div class="loading-popup" v-if="isShowPageLoading">
			<div class="loading-popup-mask"></div>
			<div class="loading-body">
				<page-loading class="loading" :bacgColor='loadingBgColor' :size="100" ></page-loading>
				<div class="loading-title">Loading</div>
				<div class="loading-tips">Detecting APP installation environment, please wait</div>
			</div>
		</div>
		<div class="loading-popup" v-if="isShowTotast">
			<div class="loading-popup-mask"></div>
			<div class="loading-body" @click.stop="isShowTotast = false">
				<div class="toast-title">Kind tips</div>
				<div class="toast-content">Your browser does not support installation yet</div>
				<div class="close-btn">Confirm</div>
			</div>
		</div>
		<guide-img v-if="showGuideImg" @closeGuideImg="closeGuideImg()"></guide-img>
	</div>
</template>

<script>
	import pageLoading from '@/components/view-loading.vue'
	import guideImg from '@/components/guideImg.vue'
	export default {
		components:{
			guideImg,
			pageLoading
		},
		data(){
			return {
				appName: 'ADS',
				deferredPrompt: null,
				system: '',
				showGuideImg: false,
				loadingBgColor: '#fff',
				isShowPageLoading: false,
				isShowTotast: false
			}
		},
		created() {
			this.system = this.getMobileOperatingSystem()
		},
		mounted() {
			
			if(this.system != 'ios'){
				this.isShowPageLoading = true
				setTimeout(()=>{
					this.isShowPageLoading = false
				},12000)
				this.$nextTick(()=>{
					this.deferredPrompt;
					var that = this
					window.addEventListener('beforeinstallprompt', (e) => {
					  e.preventDefault();
					  that.deferredPrompt = e;
					  setTimeout(()=>{
					  	that.isShowPageLoading = false
					  },1000)
					});
				})
			}
			
			
		},
		methods:{
			getMobileOperatingSystem() {
			    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
			    			
			    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
			        return 'ios';
			    } else if (userAgent.match(/Android/i)) {
			        return 'android';
			    } else {
			        return 'unknown';
			    }    
			},
			downloadApp(){
				if(this.system == 'ios'){
					this.showGuideImg = true
				} else {
					if(!this.deferredPrompt){
						this.isShowTotast = true
						return
					}
					this.deferredPrompt.prompt();
					this.deferredPrompt.userChoice.then((choiceResult) => {
					  if (choiceResult.outcome === 'accepted') {
						
					  } else {
					  }
					  // 清除保存的事件对象
					  this.deferredPrompt = null;
					});
				}
				
			},
			closeGuideImg(){
				this.showGuideImg = false
			}
			
			
			
		}
	}
</script>

<style lang="less">
	.download-page {
		padding: 16px 16px 100px 16px;
		background: #fff;
		height: 100%;
		overflow-y: scroll;
		.loading-popup {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			height: 100vh;
			width: 100vw;
			.loading-popup-mask {
				z-index: 999 !important;
				position: fixed;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				height: 100vh;
				width: 100vw;
				background: rgba(0, 0, 0,0.5);
				transform: translate(0, 0);
			}
			.loading {
				margin-top: 30px;
			}
			.loading-body {
				position: absolute;
				top: 30%;
				left: 32px;
				right: 32px;
				
				background-color: #fff;
				border-radius: 10px;
				z-index: 9999;
				text-align: center;
				padding: 16px 0;
			}
			.loading-title {
				margin-top: -60px;
			}
			.loading-tips {
				text-align: center;
				margin-top: 80px;
				padding-bottom: 32px;
				padding-left: 16px;
				padding-right: 16px;
			}
			.toast-title {
				font-size: 20px;
				font-weight: 500;
				padding-bottom: 16px;
			}
			.toast-content {
				font-size: 16px;
				text-align: left;
				padding: 16px;
				border-top: 1px solid #e0e0e0;
			}
			.close-btn {
				border-top: 1px solid #e0e0e0;
				font-size: 16px;
				background-color: #0a60fe;
				color: #fff;
				display: inline-block;
				padding: 8px 60px;
				border-radius: 40px;
			}
		}
		.page-header {
			display: flex;
			padding: 16px 0;
			.logo-img {
				width: 80px;
				height: 80px;
				margin-right: 16px;
				border-radius: 20%;
				box-shadow: 0 1px 2px #3c40434d, 0 1px 3px 1px #3c404326;
			}
			.page-header-content {
				flex: 1;
				.title-1 {
					color: #111;
					font-size: 24px;
					line-height: 24px;
					display: block;
					font-weight: 700;
					
				}
				.title-2 {
					margin-top: 5px;
					color: #0a60fe;
					font-size: 16px;
					line-height: 16px;    
					
				}
				.right-bottom {
					margin-top: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.download-btn {
						// min-width: 228upx;
						background-color: #0a60fe;
						border-radius: 15px;
						text-align: center;
						color: #fff;
						font-size: 14px;
						padding: 0 30px;
						height: 31px;
						line-height: 31px;    
					}
					.share-btn {
						width: 25px;
						height: 25px;
					}
					.doubt {
						width: 31px;
						height: 31px;
						line-height: 31px;
						border-radius: 50%;
						background-color: #0a60fe;
						color: #fff;
						font-size: 14px;
						font-weight: bold;
						text-align: center;    
					}
				}
			}
		}
		.scores-box {
			margin-top: 16px;
			margin-bottom: 16px;
			border-top: 1px solid #e0e0e0;
			padding: 16px 0;
			display: flex;
			align-items: center;
			.scores-card {
				text-align: center;
				flex: 1;
				// border-left: 1px solid #d8d8d8;
				position: relative;
				&::after{
					content: '';
					position: absolute;
					right: 0;
					top: 10px;
					width: 1px;
					height: 50px;
					background: #d8d8d8;
				}
				&:last-child{
					&::after {
						display: none;
					}
				}
				&:first-child {
					border-left: 0;
				}
				.scores-card-top {
					font-size: 13px;
					color: #8e8e93;
				}
				.scores-card-center {
					font-size: 18px;
					font-weight: 700;
					padding: 6px 0;
					color: #8e8e93;
				}
				.scores-card-bottom {
					font-size: 13px;
					color: #8e8e93;
				}
			}
		
		}
		.banner-imgs-box {
			overflow-x: auto;
			.imgs-list {
				display: flex;
				flex-wrap: nowrap;
				height: 224px;
				overflow: scroll;
				width: fit-content;    
				.app-banner-img {
					border-radius: 8px;
					margin-right: 11px;
					height: 210px;  
					width: 130px;
				}
			}
			
		}
		.introduce-box {
			margin: 24px 0;
			line-height: 17px;    
			font-family: Roboto, Helvetica, Arial, sans-serif;
			.introduce-title {
				font-size: 20px;
				font-weight: 700;
				margin-bottom: 20px;
			}
			.introduce-content {
				white-space: pre-wrap;
				font-size: 14px;    
			}
		}
		.update-box {
			margin: 24px  0;
			font-size: 14px;
			line-height: 20px;
			font-family: Roboto, Helvetica, Arial, sans-serif;
			.title {
				font-weight: 700;
				color: #202124;   
			}
			.content {
				margin-top: 4px;
			}
		}
		.install-tips {
			padding: 8px 8px 8px 8px;
			color: #666;
			border-radius: 5px; 
			margin: 16px 0;
			font-size: 14px;
			line-height:1.8;
		}
		.comments-box {
			padding: 16px 0;
			border-bottom: 1px solid #e0e0e0;
			border-top: 1px solid #e0e0e0;
			
			.comments-box-title {
				font-size: 20px;
				font-weight: bold;
				margin-bottom: 8px;
			}
			.comments-box-content {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 16px;
				.left {
					.num {
						font-size: 60px;
						color: #4c4c50;
						line-height: 1.1;
						font-weight: 700;
					}
					.tips {
						font-size: 14px;
						color: #8e8e93;
						font-weight: bold;
					}
				}
				.right {
					.star_row {
						.linebox {
							width: 140px;
							height: 3px;
							border-radius: 3px;
							background-color: #e5e5e5;
							overflow: hidden;    
							margin-bottom: 8px;
							.v1 {
								width: 130px;
								height: 3px;
								overflow: hidden; 
								background-color: #8e8e93;
							}
							.v2 {
								width: 25px;
								height: 3px;
								overflow: hidden; 
								background-color: #8e8e93;
							}
							.v3 {
								width: 15px;
								height: 3px;
								overflow: hidden; 
								background-color: #8e8e93;
							}
							.v4 {
								width: 10px;
								height: 3px;
								overflow: hidden; 
								background-color: #8e8e93;
							}
							.v5 {
								width: 5px;
								height: 3px;
								overflow: hidden; 
								background-color: #8e8e93;
							}
						}
						
					}
					.tips {
						font-size: 14px;
						color: #8e8e93;
						line-height: 1.4;
						text-align: right;    
					}
				}
			}
		}
		.new-fun-box {
			padding: 16px 0;
			border-bottom: 1px solid #e0e0e0;
			.title {
				font-size: 20px;
				font-weight: bold;
				margin-bottom: 16px;
			}
			.content {
				font-size: 15px;
				color: #333;
			}
		}
		.info-box {
			padding: 16px 0;
			.title {
				font-size: 20px;
				font-weight: bold;
				margin-bottom: 16px;
			}
			.info-box-cell {
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #e0e0e0;
				font-size: 13px;
				padding: 10px 0;
				.left {
					color: #8e8e93;
				}
				.right {
					color: #333;
					text-align: right;
				}
			}
		}
		.disclaimer {
			padding: 16px;
			background-color: #eee;
			color: #a9a9a9;
			line-height: 1.6;    
			font-size: 12px;
			.content {
				text-indent: 25px;
			}
		}
		.ios-tip {
			position: fixed;
			bottom: 20px;
			padding: 10px 0;
			background-color: rgba(0, 0, 0, 0.7);
			justify-content: center;
			border-radius: 8px;
			left: 0;
			right: 0;
			width: 58%;
			margin: 0 auto;
			animation: zoomIn 2s infinite ease-in-out;   
			.arrow-up {
				 position: absolute;
				 bottom: 11px;
				 left: 50%;
				  &::after{
				  	position: absolute;
				  	display: inline-block;
				  	top: 3px;
				  	left: -10px;
				  	width: 0;
				  	height: 0px;
				  	content: '';
				  	border-style: solid;
				  	border-width: 8px;
				  	border-color: #000000b3 #000000b3 transparent transparent;
				  	transform: rotate(135deg);
				  	box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.1);					   
				  } 
					  
			}
			.info-text {
				 display: flex;
				 align-items: center;
				 justify-content: center; 
				 font-size: 14px;
				 color: #fff;
				.tips-logo-img {
					width: 46px;
					height: 46px;
					border-radius: 6px;
					margin-right: 10px;
				}
				.ios-share-img {
					width: 20px;
					height: auto;
					margin-left: 5px;
				}	
				.text-left {
					display: flex;
					align-items: center;
					margin-bottom: 5px;
				}
			}
		}
		.footer-title {
			text-align: center;
			margin: 16rpx 0;
			font-size: 14px;
		}
		@keyframes zoomIn {
			0% {
			    transform: scale(1);
			}
			
			50% {
			    transform: scale(1.1);
			}
			100% {
			    transform: scale(1);
			}
		}
	}
</style>